export default "__VITE_ASSET__CngVqgSI__"